import Vue from 'vue'
import './config'
import './filter'
import './validator'
import './directive'
import './components'
import './polifill'
import axios from '@/client/axios'
import Plugins from './plugins'
import App from './App.vue'
import router from './router'
import store from './store'

// CSS
import 'animate.css/animate.css'
import 'slick-carousel/slick/slick.css'
import '@fortawesome/fontawesome-free/css/all.css'
// import 'css-ripple-effect/dist/ripple.min.css'

// Scripts
import 'cssist'
import WOW from 'wow.js/dist/wow.js'

// Service
import AuthService from '@/service/auth/AuthService'
import StatusService from '@/service/status/StatusService'
import ChannelService from '@/service/channeltalk/ChannelService'

// Node Modules: JS

window.$ = window.jQuery = require('jquery')

// Variable Section

Vue.config.productionTip = false
let { vuetify } = Plugins

window.DEBUGON = true
if (window.DEBUGON === true) {
  if (['http://localhost:8080', 'http://192.168.0.185:8080'].includes(location.origin)) {
    window.DEBUG = true
  } else {
    window.DEBUG = false
  }
}

// Function Section

window.isEmpty = function (v) {
  return !!(v == null || v.length === 0)
}

window.tokenlogin = function (token) {
  if (!token) {
    alert('잘못된 형식입니다. 이쁘게 넣어주세요! from Sun')
    return
  }
  token = token.trim()
  localStorage.removeItem('frtk')
  localStorage.removeItem('ftk')
  localStorage.setItem('frtk', token)
  localStorage.setItem('ftk', token)
  // location.reload()
  location.href = '/?pass_code=success'
}

async function init() {
  try {
    await axios({ url: `${store.state.env.baseURL}/ping/`, method: 'GET' })
  } catch (e) {
    router.push({ name: 'maintenance' })
  }

  // 기본 프로파일 최초에 불러오게 수정
  try {
    await AuthService.syncProfile()
    await StatusService.syncStatus()
    ChannelService.boot()
  } catch (e) {
    throw e
  } finally {
    global.$vm = new Vue({
      router,
      store,
      vuetify,
      mounted() {
        new WOW().init()
      },
      render: h => h(App)
    }).$mount('#app')
  }
}

// Main Section

init()
